import { api as url } from './';
import serialize from './Serialize';
import axios from './axiosConfig';
import { checkAndHandleAuthError } from './authErrorHandler';

//Handles all post requests including file uploads, Bearer token is compulsory,
//only authenticated users can post data to api
const PostRequest = async (form, uri, token = '', progressObserver = () => {}, patch = false) => {
    let formData = serialize(form);

    if (patch) {
        formData.append('_method', 'patch');
    }

    try {
        const response = await axios.post(url + uri, formData, {
            headers: {
                Accept: 'application/json',
                Authorization: 'Bearer ' + token
            },
            onUploadProgress: progressObserver
        });

        // Check for authentication errors and handle with error preservation
        checkAndHandleAuthError(response.data);

        return response.data;
    } catch (error) {
        // Handle axios error responses
        if (error.response) {
            // Check if error response contains authentication error
            checkAndHandleAuthError(error.response.data);
        }
        throw error;
    }
};

export { PostRequest };
